module.exports = __webpack_public_path__ + "img/ico_logout.73364a1a.svg";